import { render, staticRenderFns } from "./TrainingEnrollmentForm.vue?vue&type=template&id=25fd2819&"
import script from "./TrainingEnrollmentForm.vue?vue&type=script&lang=js&"
export * from "./TrainingEnrollmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports